var _rect, _rect2, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F6F6F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    rx: 12,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0644 7.99598C15.3017 7.91009 13.8417 9.29455 13.8043 11.0294C13.8042 11.0332 13.8029 11.0332 13.8028 11.0294C13.7654 9.29455 12.3054 7.91011 10.5427 7.99598C8.60685 8.09033 7.32201 9.98379 7.66193 11.8919C8.23368 15.1011 12.1833 17.3107 13.4284 17.9338C13.6648 18.0521 13.9423 18.0521 14.1787 17.9338C15.4238 17.3107 19.3734 15.1011 19.9451 11.8919C20.2851 9.98379 19.0002 8.09033 17.0644 7.99598Z",
    fill: "url(#paint0_radial_7422_7015)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69846 12.0744C7.70538 12.1057 7.71248 12.137 7.72001 12.1682C7.72407 12.185 7.72827 12.2017 7.7325 12.2184C7.73999 12.2479 7.74779 12.2774 7.75583 12.3068C7.76033 12.3232 7.76478 12.3396 7.76945 12.3559C7.77853 12.3878 7.78806 12.4194 7.79778 12.4511C7.80181 12.4642 7.80563 12.4774 7.80977 12.4904C7.82369 12.5344 7.83818 12.5782 7.85331 12.6218C7.85671 12.6315 7.86036 12.6412 7.86382 12.651C7.87587 12.685 7.8882 12.719 7.90099 12.7527C7.90714 12.769 7.91354 12.7852 7.91985 12.8014C7.9305 12.8287 7.94129 12.8559 7.95238 12.883C7.95952 12.9005 7.96676 12.9179 7.97412 12.9354C7.98516 12.9616 7.99649 12.9877 8.00794 13.0138C8.01543 13.0308 8.02285 13.0478 8.0305 13.0648C8.04349 13.0935 8.05686 13.122 8.07031 13.1506C8.07679 13.1643 8.08305 13.1781 8.08963 13.1917C8.10899 13.2319 8.12886 13.2718 8.14915 13.3116C8.15768 13.3283 8.16652 13.3448 8.17523 13.3614C8.18796 13.3858 8.20076 13.4102 8.21385 13.4344C8.2242 13.4536 8.23477 13.4727 8.24536 13.4918C8.25725 13.5132 8.26925 13.5346 8.28141 13.556C8.29272 13.5758 8.30408 13.5956 8.31561 13.6153C8.3275 13.6357 8.33958 13.6559 8.35168 13.6761C8.36368 13.6962 8.37562 13.7163 8.38783 13.7362C8.39983 13.7557 8.4121 13.7751 8.42432 13.7945C8.44938 13.8344 8.47485 13.8741 8.50077 13.9135C8.51084 13.9289 8.52078 13.9443 8.53099 13.9596C8.54645 13.9827 8.5622 14.0056 8.5779 14.0286C8.58814 14.0435 8.59836 14.0585 8.6087 14.0733C8.62496 14.0967 8.6414 14.1199 8.65792 14.143C8.66772 14.1568 8.67755 14.1704 8.68743 14.1841C8.70492 14.2082 8.72246 14.2323 8.74022 14.2562C8.74824 14.267 8.75634 14.2777 8.76441 14.2885C8.83421 14.3816 8.90608 14.4732 8.97995 14.5633C8.98025 14.5637 8.98056 14.5641 8.98086 14.5644C9.00458 14.5934 9.02859 14.6221 9.0527 14.6507L9.06711 14.6678C9.09099 14.6961 9.11507 14.7241 9.1393 14.752L9.15116 14.7656C9.31543 14.954 9.48738 15.1354 9.66444 15.3096L9.66883 15.314C11.0335 16.6551 12.697 17.5682 13.4282 17.9341C13.6645 18.0524 13.942 18.0524 14.1784 17.9341C14.6932 17.6765 15.6703 17.1475 16.6798 16.3889L12.272 11.981C11.9917 11.6723 11.6033 11.4676 11.1486 11.4454C10.3871 11.4083 9.72975 11.8755 9.48036 12.5418L8.93663 12.0011C8.61258 11.6427 8.13737 11.4236 7.61133 11.4451C7.61298 11.4793 7.61525 11.5135 7.61792 11.5478C7.61868 11.5577 7.61965 11.5676 7.6205 11.5775C7.62261 11.602 7.62494 11.6265 7.62758 11.651C7.62881 11.6626 7.63013 11.6742 7.6315 11.6858C7.63433 11.7099 7.63746 11.734 7.64081 11.7581C7.64227 11.7686 7.64364 11.7791 7.6452 11.7897C7.65025 11.8238 7.65566 11.858 7.66176 11.8922C7.66999 11.9384 7.67913 11.9845 7.68877 12.0303C7.69184 12.0451 7.69525 12.0597 7.69846 12.0744Z",
    fill: "url(#paint1_linear_7422_7015)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1491 11.4454C10.1894 11.3987 9.39448 12.1525 9.37408 13.097C9.37406 13.0991 9.37332 13.0991 9.37329 13.097C9.35292 12.1524 8.55797 11.3987 7.59823 11.4454C6.54416 11.4968 5.8446 12.5277 6.02968 13.5667C6.34097 15.314 8.49148 16.5171 9.16944 16.8564C9.2981 16.9208 9.44925 16.9208 9.57791 16.8564C10.2559 16.5171 12.4064 15.314 12.7177 13.5667C12.9028 12.5277 12.2032 11.4968 11.1491 11.4454Z",
    fill: "url(#paint2_linear_7422_7015)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_7422_7015",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.6214 10.7431) scale(6.8141 5.51536)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4497,
    stopColor: "#FE4773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6292,
    stopColor: "#FC406D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7605,
    stopColor: "#F73464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8683,
    stopColor: "#F12257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9606,
    stopColor: "#E80C46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4003D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7422_7015",
    x1: 16.6622,
    y1: 15.7337,
    x2: 14.6164,
    y2: 11.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4003D",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4003D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7422_7015",
    x1: 5.60348,
    y1: 12.8515,
    x2: 7.90415,
    y2: 17.0217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1758,
    stopColor: "#FFDE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4446,
    stopColor: "#FFCA65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#FFAA87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF90A4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove);
export default __webpack_public_path__ + "static/media/love.8816886f94015b763cb384258313b47d.svg";
export { ForwardRef as ReactComponent };